import React from "react";

export default function IntroStep({ intro, onContinue }) {
  return (
    <div className="survey-step">
      <h2 className="survey-headline">{intro.headline}</h2>
      <p className="survey-explanation">{intro.text}</p>
      <button className="survey-continue joystix" onClick={onContinue} type="button">
        {intro.continueLabel}
      </button>
    </div>
  );
}
